<app>
    <router base={base}>
        <div if={state.user}>
            <route path="#/commesse">
                <main-navi></main-navi>
                <main class="py-10 lg:pl-72">
                    <div class="px-4 sm:px-6 lg:px-8">
                        <commesse></commesse>
                        <my-footer></my-footer>
                    </div>
                </main>
            </route>
            <route path="#/commesse/:id_commessa">
                <main-navi></main-navi>
                <main class="pt-10 lg:pl-72">
                    <div class="px-4 sm:px-6 lg:px-8">
                        <commessa key="{ route.params.id_commessa }" id_commessa="{ route.params.id_commessa }"></commessa>
                        <my-footer></my-footer>
                    </div>
                </main>
            </route>
            <route path="#/tasks">
                <main-navi></main-navi>
                <main class="py-10 lg:pl-72">
                    <div class="px-4 sm:px-6 lg:px-8">
                        <tasks></tasks>
                        <my-footer></my-footer>
                    </div>
                </main>
            </route>
        </div>
        <div if={!state.user}>
            <!-- L'utente non è autenticato, mostrare la pagina di login o registrazione -->
            <login></login>
            <div class="px-4 sm:px-6 lg:px-8">
                <my-footer></my-footer>
            </div>
        </div>
        <modal-error></modal-error>
    </router>

    <script>
        import StoreService from '/src/services/store';
        import eventBus from '/src/utils/event-bus';
        import { router } from '@riotjs/route';
        import { EVENTS } from '/src/utils/constants';
        import { beforeRoute } from '/src/utils/functions';

        const loc = window.location;

        export default {
            base: `${loc.pathname}/`,
            beforeRoute,
            onBeforeMount() {
                const user = StoreService.getUser()
                this.state = {
                    user: user
                }
                const currentPath = window.location.hash
                if (user && (!currentPath || currentPath === '#/' || currentPath === '#')) {
                    history.replaceState({}, '', '#/commesse')
                }
            },

            async onMounted() {
                eventBus.on(EVENTS.AUTH.LOGIN_SUCCESS, (user) => {
                    this.update({user: user})
                    const path = '#/commesse'
                    history.pushState({}, '', path)
                    router.push(path)
                })

                eventBus.on(EVENTS.AUTH.LOGOUT_SUCCESS, (e) => {
                    this.update({user: null})
                })

                eventBus.on(EVENTS.UI.GENERIC_ERROR, (e) => {
                    if (e.code === 209) {
                        eventBus.trigger(EVENTS.AUTH.LOGOUT, e);
                    } else {
                        console.error(e)
                        eventBus.trigger(EVENTS.UI.OPEN_MODAL_ERROR, {
                            ckey: "error",
                            title: "Errore generico",
                            text: e.error
                        });
                    }
                })
            },

            onBeforeUnmount() {
                eventBus.off(EVENTS.AUTH.LOGIN_SUCCESS)
                eventBus.off(EVENTS.AUTH.LOGOUT_SUCCESS)
                eventBus.off(EVENTS.UI.GENERIC_ERROR)
            }
        };
    </script>
</app>
